import { EngineReportType } from '@navstation-portal/reporting/data-model/engine-reports';
import { EngineReport } from './engine-report';

export const ENGINE_REPORT_STORE_ID = 'EngineReportStore';

export interface EngineReportState {
  readonly creatingReport: boolean;
  readonly reportType: EngineReportType | null;
  readonly localReportId: string | null;
  readonly report: EngineReport | null;
  readonly loadingReport: boolean;
  readonly reportNotFound: boolean;
}

export const INITIAL_ENGINE_REPORT_STATE: EngineReportState = {
  creatingReport: false,
  reportType: null,
  localReportId: null,
  report: null,
  loadingReport: false,
  reportNotFound: false,
};
